///<reference path="../../typings/index.d.ts"/>
/// <reference path="../../node_modules/inversify/dts/inversify.d.ts" />
/// <reference path="../../node_modules/axios/axios.d.ts" />
///<reference path="./globals.d.ts"/>

import "reflect-metadata";
import {AppCtx} from "./ioc/ApplicationContext";

import "./ioc/ApplicationContext";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {Router} from 'react-router';
import * as History from "react-router"
import {routes} from './routing/Routes'
import {wire} from "./ioc/ApplicationSetup";
import {kernel} from "./ioc/IOCHelper";
import {HttpService, HTTP_SERVICE_NAME} from "./service/http/HttpService";
import {ClientConfig} from "../generated/protocol";


(window as any).contextPath = document.location.pathname.startsWith("/dashboard") ? "/dashboard" : "";

wire();

var httpService = kernel.get<HttpService>(HTTP_SERVICE_NAME);

httpService.doGet("/dashboard-user/client-config").then((clientConfig: ClientConfig) => {
    $("html").addClass("environment-" + clientConfig.environmentType);
    var element = document.getElementById('app');
    (window as any).legacyPokerAdminUrl = clientConfig.legacyPokerAdminUrl;
    (window as any).oktaEnabled = clientConfig.oktaEnabled;
    (window as any).oktaAuthUrl = clientConfig.oktaAuthUrl;
    (window as any).oktaClientId = clientConfig.oktaClientId;
    (window as any).oktaRedirectUrl = clientConfig.oktaRedirectUrl;
    (window as any).adminBaseUrl = clientConfig.adminBaseUrl;
    ReactDOM.render(
        <Router history={History.hashHistory} onUpdate={() => {
            AppCtx.getUserActions().resetForbiddenStatus();
        }}>
            {routes}
        </Router>,
        element
    );

}).catch(err => {
    $("body").append("Unable to load application config");
});

function loadVersionInfo() {
    (window as any).appversion = document.querySelector("meta[name='appversion']").getAttribute('content');
}

loadVersionInfo();



// WEBPACK FOOTER //
// ./src/app/ReactApp.tsx